import { useEffect, useRef, useTransition } from 'react';
import { useParams } from 'next/navigation';
import { useTranslations } from 'next-intl';
import { useAtom } from 'jotai';
import { useResetAtom } from 'jotai/utils';
import { debounceTime, Subject } from 'rxjs';

import { KafkaNote } from '@nf/utils-common/constants';
import { keywordAtom } from '@/atoms/league-filter';
import { setKafkaNormal } from '@/hooks/query/use-kafka-log';

import { Button } from '@nf/ui';
import { CloseRoundIcon } from '@/components/icons/svg-icons';

export const SearchInput = () => {
	const t = useTranslations('General');
	const params = useParams();
	const [keyword, setKeyword] = useAtom(keywordAtom);
	const [isPending, startTransition] = useTransition();
	const resetKeyword = useResetAtom(keywordAtom);

	const keywordSubject = useRef(new Subject<string>());

	useEffect(() => {
		const subscription = keywordSubject.current
			.pipe(
				debounceTime(500)
			)
			.subscribe(value => {
				setKafkaNormal({
					note: KafkaNote.MarsV1,
					type: 3,
					action: 9
				});
			});

		return () => subscription.unsubscribe();
	}, []);

	const changeKeyword = (event: React.ChangeEvent<HTMLInputElement>) => {
		const newValue = event.target.value;

		if (params.sport === '1') {
			keywordSubject.current.next(newValue);
		}

		startTransition(() => {
			setKeyword(newValue);
		});
	};
	
	return (
		<>
			<input 
				className="input" 
				placeholder={t('lbl_SearchLeague')}  
				value={keyword}
				onChange={changeKeyword}
			/>

			{keyword ? (
				<Button 
					variant="icon"
					onClick={resetKeyword}
				>
					<CloseRoundIcon />
				</Button>
			) : null}
		</>
	);
};